export const sxStyle = {
  modalHotelMapFullWidth: {
    position: 'absolute',
    cursor: 'pointer',
    width: { xs: '60%', sm: '15%' },
    ml: '1.25%',
    mt: '5px',
  },

  modalHotelMap: {
    position: 'absolute',
    cursor: 'pointer',
    width: { xs: '250px', sm: '55%', md: '45%' },
    ml: '1.25%',
    mt: '5px',
  },
};
